import { sendRequest, tokenRefresh } from '@/api'

export const LOCALES = ['pl', 'en']

const loadFanzones = async (store) => {
  const { ok, data } = await sendRequest('get', `api/fanzine/all/`)
  if (ok) {
    store.dispatch('setFanzones', { fanzones: data.data })
  }
}

const loadPlaces = async (store) => {
  const { ok, data } = await sendRequest('get', `api/places/`)
  if (ok) {
    store.dispatch('setPlaces', { places: data.data })
  }
}

const loadArtists = async (store) => {
  const { ok, data } = await sendRequest('get', `api/artist/all/`)
  if (ok) {
    store.dispatch('setArtists', { artists: data.data })
  }
}

export const loadInitData = async (store) => {
  store.dispatch('setLoading', { loading: true })
  await tokenRefresh()
  await loadFanzones(store) 
  //await loadPlaces(store)
  await loadArtists(store)
  store.dispatch('setLoading', { loading: false })
}
